export const barData = [
	{
		id: 1,
		name: 'Волжский государственный университет водного транспорта',
		shortName: 'ВГУВТ',
		registered: 2,
		nominationSelected: 3,
		formSubmitted: 4,
	},
	{
		id: 2,
		name: 'ГУМРФ им. адмирала С.О. Макарова',
		shortName: 'ГУМРФ',
		registered: 3,
		nominationSelected: 4,
		formSubmitted: 5,
	},
	{
		id: 3,
		name: 'Дальневосточный государственный университет путей сообщения',
		shortName: 'ДВГУПС',
		registered: 2,
		nominationSelected: 3,
		formSubmitted: 4,
	},
	{
		id: 4,
		name: 'Иркутский государственный университет путей сообщения',
		shortName: 'ИрГУПС',
		registered: 3,
		nominationSelected: 4,
		formSubmitted: 5,
	},
	{
		id: 5,
		name: 'Морской государственный университет им. Г.И. Невельского',
		shortName: 'МГУ',
		registered: 2,
		nominationSelected: 3,
		formSubmitted: 4,
	},
	{
		id: 6,
		name: 'Омский государственный университет путей сообщения',
		shortName: 'ОмГУПС',
		registered: 2,
		nominationSelected: 3,
		formSubmitted: 4,
	},
	{
		id: 7,
		name: 'Приволжский государственный университет путей сообщения',
		shortName: 'ПРГУПС',
		registered: 1,
		nominationSelected: 2,
		formSubmitted: 3,
	},
	{
		id: 8,
		name: 'Ростовский государственный университет путей сообщения',
		shortName: 'РГУПС',
		registered: 1,
		nominationSelected: 2,
		formSubmitted: 3,
	},
	{
		id: 9,
		name: 'Российский университет транспорта',
		shortName: 'РУТ',
		registered: 4,
		nominationSelected: 6,
		formSubmitted: 8,
	},
	{
		id: 10,
		name: 'Сибирский государственный университет путей сообщения',
		shortName: 'СГУПС',
		registered: 2,
		nominationSelected: 3,
		formSubmitted: 4,
	},
	{
		id: 11,
		name: 'Сибирский государственный автомобильно-дорожный университет',
		shortName: 'СибАДИ',
		registered: 2,
		nominationSelected: 3,
		formSubmitted: 4,
	},
	{
		id: 12,
		name: 'Ульяновский институт гражданской авиации',
		shortName: 'УИГА',
		registered: 2,
		nominationSelected: 3,
		formSubmitted: 4,
	},
	{
		id: 13,
		name: 'Уральский государственный университет путей сообщения',
		shortName: 'УрГУПС',
		registered: 2,
		nominationSelected: 3,
		formSubmitted: 4,
	},
];

export const pieData = [
  {
    id: 'Территория роста',
    label: 'Территория роста',
    value: 200,
  },
  {
    id: 'Технологии партнерства',
    label: 'Технологии партнерства',
    value: 160,
  },
  {
    id: 'Педагогический прием',
    label: 'Педагогический прием',
    value: 80,
  },
  {
    id: 'Технологии и инновации',
    label: 'Технологии и инновации',
    value: 175,
  },
  {
    id: 'Цифровой педагог',
    label: 'Цифровой педагог',
    value: 70,
  }
];

export const customColors = [
  '#4CAF50',
  '#F57C00',
  '#D32F2F',
  '#073AE9',
  '#7B1FA2'
];
